// Damage formulas. Min damage 10.

export const MIN_DAMAGE = 10;

export function physicalDamage(ad: number): number {
  return Math.max(MIN_DAMAGE, Math.round(ad));
}

export function magicDamage(ap: number): number {
  return Math.max(MIN_DAMAGE, Math.round(ap));
}
